import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-CDesign";
import leftimgs from "../../../assets/aileftimg.png";
import rightimgs from "../../../assets/airightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/ai-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/ai-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/ai-benefit-img3.png";
import BenefitsDataImg4 from "../../../assets/ai-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/ai-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/ai-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/ai-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/ai-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/ai-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/aiFun-img1.png";
import FunactivitiesImg2 from "../../../assets/aiFun-img2.png";
import FunactivitiesImg3 from "../../../assets/aiFun-img3.png";
import FunactivitiesImg4 from "../../../assets/aiFun-img4.png";
import FunactivitiesImg5 from "../../../assets/aiFun-img5.png";
import LearningStyle from "../../../MyComponents/LearningStyle"
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

import Testimonials from "../../../MyComponents/Testimonials";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "10",
      classes: "05",
      description: "  Introduction to Data Science- Learn data types, collection, organization, and use Python to analyze and visualize data.",
    },
    {
      title: "Module 2",
      activities: "10",
      classes: "05",
      description: " Data Cleaning & Preprocessing - Understand techniques like imputation and normalization, and grasp basic statistics and probability.",
    },
    {
      title: "Module 3",
      activities: "10",
      classes: "05",
      description:" Machine Learning - Explore supervised and unsupervised learning, make predictions, and evaluate model performance.",
    },
    
  ];

  


  const benefitsData = [
      {
        title: "Collect & Organize Data",
        description: "Gather, structure, and manage datasets effectively.",
        icon: "Polymath-images/ai-benefit-img1.png"
      },
      {
        title: "Write Python Code",
        description: "Develop scripts for data analysis and automation.",
        icon: "Polymath-images/ai-benefit-img2.png",
      },
      {
        title: "Create Visualizations",
        description: "Design charts and graphs to represent data clearly.",
        icon: "Polymath-images/ai-benefit-img3.png",
      },
      {
        title: "Clean & Preprocess Data",
        description: "Fix, format, and prepare raw data for analysis.",
        icon: "Polymath-images/ai-benefit-img4.png",
      },
      {
        title: "Verify Data Accuracy",
        description: "Ensure reliability by detecting and correcting errors.",
        icon: "Polymath-images/ai-benefit-img5.png",
      },
      {
        title: "Analyze Statistical Concepts",
        description: "Interpret key metrics like mean, median, and mode.",
        icon: "Polymath-images/ai-benefit-img6.png",
      },
      {
        title: "Implement Machine Learning",
        description: "Apply algorithms to uncover patterns and insights.",
        icon: "Polymath-images/ai-benefit-img7.png",
      },
      {
        title: "Test & Evaluate Models",
        description: "Assess prediction accuracy and model performance.",
        icon: "Polymath-images/ai-benefit-img8.png",
      },
      {
        title: "Deploy ML Solutions",
        description: "Use trained models to make real-time predictions.",
        icon: "Polymath-images/ai-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "Data Cleaning",
          image: "Polymath-images/aiFun-img1.png",
        },
        {
          title: "Bar Charts & Graphs",
          image: "Polymath-images/aiFun-img2.png",
        },
        {
          title: "Data Classification",
          image: "Polymath-images/aiFun-img3.png",
        },
        {
          title: "Data Normalisation",
          image: "Polymath-images/aiFun-img4.png",
        },
        {
          title: "Prediction & Evaluation",
          image: "Polymath-images/aiFun-img5.png",
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const AIDataScience = () => {
  const Scratchpage = heroContent.aisection;
  return (
    <>
       {/* <GuestNav/> */}
      <HeadSection
      leftImg={'Polymath-images/aileftimg.png'}
      rightImg={'Polymath-images/airightimg.png'}
      titlePart1="AI Data Science"
      titlePart2="Course"
      description="Polymath-kids offer comprehensive online AI & Data Science course. The online classes’ offers two modes -online 1:1 classes and online group classes with trained teachers having years of experience in Computer Sciences."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={"Polymath-images/pencil.png"}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
              title1="Course Structure & Syllabus"
              // title="Beginner Level Course"
              modules={beginnerModules}
            />
          
       <Benefits
        title="How Students Can Benefit From AI & Data Science"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Kidprenur Course"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default AIDataScience 